import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { StorageConstants } from '../constant/storage.constant';
import { environment } from '../../environments/environment';
import { throwError as observableThrowError, Observable } from "rxjs";
import { SessionStorageService } from './session-storage.service';
export class BaseRestService {

  constructor(protected httpClient: HttpClient, protected sessionStorageService: SessionStorageService) {
  }

  protected httpGet<T>(url: string, excludeAuth?: boolean, params: HttpParams = new HttpParams()): Observable<any> {
    const fullUrl = this.buildFullUrl(url);
    return this.httpClient.get<any>(fullUrl, { headers: excludeAuth ? this.headersWithoutAuthorization : this.headersWithAuthorization, params });
  }

  protected httpDelete<T>(url: string, excludeAuth?: boolean, params: HttpParams = new HttpParams()): Observable<any> {
    const fullUrl = this.buildFullUrl(url);
    return this.httpClient.delete<any>(fullUrl, { headers: excludeAuth ? this.headersWithoutAuthorization : this.headersWithAuthorization, params });
  }

  protected httpPost<T>(url: string, data: any, excludeAuth?: boolean, params: HttpParams = new HttpParams()): Observable<any> {
    const fullUrl = this.buildFullUrl(url);
    return this.httpClient.post<any>(fullUrl, data, { headers: excludeAuth ? this.headersWithoutAuthorization : this.headersWithAuthorization, params });
  }

  protected httpPut<T>(url: string, data: any, excludeAuth?: boolean, params: HttpParams = new HttpParams()): Observable<any> {
    const fullUrl = this.buildFullUrl(url);
    return this.httpClient.put<any>(fullUrl, data, { headers: excludeAuth ? this.headersWithoutAuthorization : this.headersWithAuthorization, params });
  }
  // PDF dosyaları için özel POST metodu
  protected httpPostForPdf(url: string, data: any, excludeAuth?: boolean, params: HttpParams = new HttpParams()): Observable<Blob> {
    // PDF dosyaları için özel ayarlar
    const fullUrl = this.buildFullUrl(url);
    const options = {
      headers: excludeAuth ? this.headersWithoutAuthorization : this.headersWithAuthorization,
      params: params,
      responseType: 'blob' as 'json' // Angular'ın responseType'u blob olarak algılaması için bu şekilde ayarlanmalı
    };

    return this.httpClient.post<Blob>(fullUrl, data, options);
  }

  errorHandler(error: HttpErrorResponse) {
    //
    // console.log(error);
    return observableThrowError(error);
  }

  /**
   * API URL'ini güvenli bir şekilde oluşturur
   * @param url API endpoint'i
   * @returns Tam URL
   */
  private buildFullUrl(url: string): string {
    // Environment apiUrl kontrolü
    if (!environment || !environment.apiUrl) {
      console.error('Environment apiUrl is not defined!', environment);
      throw new Error('API URL is not configured. Please check environment configuration.');
    }

    // URL'nin başında / olup olmadığını kontrol et
    const cleanUrl = url.startsWith('/') ? url : '/' + url;
    const fullUrl = environment.apiUrl + cleanUrl;

    // URL'nin geçerli olup olmadığını kontrol et
    if (!fullUrl || fullUrl === 'undefined' || fullUrl === 'null') {
      console.error('Invalid URL constructed:', { environment: environment?.apiUrl, url, fullUrl });
      throw new Error('Invalid API URL constructed. Please check environment configuration.');
    }

    return fullUrl;
  }


  get headersWithAuthorization(): HttpHeaders {
    let headers = new HttpHeaders();

    let languageCode = localStorage.getItem(StorageConstants.LANGUAGE_CODE);
    headers = headers.set('Authorization', `Bearer ${this.sessionStorageService.getString(StorageConstants.TOKEN_KEY)}`);
    headers = headers.set('x-owner-id', `${this.sessionStorageService.getString(StorageConstants.OWNER_ID)}`);

    // headers = headers.set('Accept', '*/*');
    // headers = headers.set('Access-Control-Allow-Origin', '*');
    // headers = headers.set('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, HEAD');
    headers = headers.set('Content-Type', 'application/json');
    // headers = headers.set('Access-Control-Allow-Headers', '*');
    headers = headers.set('x-app-version', environment.VERSION);
    headers = headers.set('x-app-platform', 'WEB');

    if (languageCode != null)
      headers = headers.set('Accept-Language', languageCode);
    // headers = headers.set('timeout', '100000');

    return headers;
  }
  get headersWithoutAuthorization(): HttpHeaders {
    let headers = new HttpHeaders();
    let languageCode = localStorage.getItem(StorageConstants.LANGUAGE_CODE);

    // headers = headers.set('Accept', '*/*');
    // headers = headers.set('Access-Control-Allow-Origin', '*');
    // headers = headers.set('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, HEAD');
    headers = headers.set('Content-Type', 'application/json');
    // headers = headers.set('Access-Control-Allow-Headers', '*');
    headers = headers.set('x-app-version', environment.VERSION);

    headers = headers.set('x-app-platform', 'WEB');
    if (languageCode != null)
      headers = headers.set('Accept-Language', languageCode);
    // headers = headers.set('timeout', '100000');

    return headers;
  }
}


